import create from 'zustand'
import { persist } from "zustand/middleware"

const persistConfig = {
  name: "csrf-token-secret"
};

const csrfTokenStore = create(persist((set, get) => {

  const setGoogleStateAction = async (googleState) => {
    set({ googleState })
  }

  const setLineStateAction = async (lineState) => {
    set({ lineState })
  }

  const setFacebookStateAction = async (facebookState) => {
    set({ facebookState })
  }

  const setAppleStateAction = async (appleState) => {
    set({ appleState })
  }

  const clearAllAction = () => set({
    ...initState
  })

  const initState = {
    googleState: null,
    lineState: null,
    facebookState: null,
    appleState: null
  }
  
  return {
    ...initState,
    setGoogleState: setGoogleStateAction,
    setLineState: setLineStateAction,
    setFacebookState: setFacebookStateAction,
    setAppleState: setAppleStateAction,
    clearAll: clearAllAction,
  }
}, persistConfig));

export default csrfTokenStore;